import _ from './footer.module.scss'
import React, {useEffect, useRef, useState} from 'react'
import {$, $$$} from '../shared/class-name'
import {useSharedStore} from '../state/shared-store-context'
import {isTitleScrolling, markRolloutDone} from '../shared/audio/title'
import {RollingTitle} from '../apps/aife/components/rolling-title'
import {useHideAwarePosition} from '../hooks/use-hide-aware-position'
import {useMobileFirst} from '../hooks/use-mobile-first'
import {FooterNotifications} from '../apps/outof195/components/notifications/footer-notifications'
import {useLocation} from 'react-router-dom'
import {useIsMobile} from '../hooks/use-is-mobile'

const TITLE_ANCHOR_ID = '_f7a'
let timeout

export const Footer = () => {
    const [copyrightVisible, setCopyrightVisible] = useState(true)
    const {sharedState} = useSharedStore()
    const observerRef = useRef(null)
    const rootRef = useRef(null)
    const mobileFirst = useMobileFirst()
    const isMobile = useIsMobile()

    useEffect(() => {
        if (sharedState.portfolioMode) {
            toggleCopyrightVisibility()
        } else {
            clearTimeout(timeout)
            setCopyrightVisible(true)
        }
        return () => clearTimeout(timeout)
    }, [sharedState.portfolioMode])

    useEffect(() => {
        const handleObserver = (entries) => {if (!entries[0]?.isIntersecting && !isTitleScrolling()) markRolloutDone()}
        observerRef.current = new IntersectionObserver(handleObserver, {threshold: 1.0})
        const target = document.querySelector(`#${TITLE_ANCHOR_ID}`)
        if (target) observerRef.current.observe(target)
        return () => {
            target && observerRef.current.unobserve(target)
            clearTimeout(timeout)
        }
    }, [])

    const toggleCopyrightVisibility = () => {
        setCopyrightVisible(prev => !prev)
        timeout = setTimeout(toggleCopyrightVisibility, 5000)
    }
    const preHidden = (sharedState.footerContent == null || sharedState.scrolledPast320) && !sharedState.noHideFooter
    const {position, hidden, noTransition, content, backdropFilterEnabled
    } = useHideAwarePosition(sharedState.floatingFooterPosition, preHidden, sharedState.footerContent)
    const {pathname} = useLocation()
    const profileUserId = sharedState.routeParams.profileUserId || sharedState.routeParams.userId || null
    const isNetworkRoot = pathname.startsWith('/network') && !profileUserId

    return <><div ref={rootRef} className={$$$(
        $(_.root),
        $(_.mobileFirst, mobileFirst),
        $(_.hidden, hidden),
        $(_.noTransition, noTransition),
        $(_.titleMode, sharedState.isTitleScrolling),
        $(_.floating, sharedState.floatingFooter),
        $(_.left, position === 'left'),
        $(_.right, position === 'right'),
        $(_.white, sharedState.footerColor === 'white'),
        $(_[`_${sharedState.footerColumnCount || 5}columns`]),
        $(_.profile, sharedState.footerProfile),
        $(_.backdropFilterEnabled, backdropFilterEnabled),
    )} data-layout="footer">
        <div className={$$$($(_.content), $(_.signatureVisible, !copyrightVisible))}>
            <span className={$$$($(_.leftContainer), $(_.fullWidth, !sharedState.portfolioMode))}>
                {content}
            </span>
            <div className={$$$($(_.rightContainer), $(_.rightContainerVisible, sharedState.portfolioMode))} style={{height: '100%', lineHeight: '1.6'}}>
                {sharedState.footerRightContainerContent?.({copyrightVisible})}
            </div>
        </div>
        {isMobile && <div className={_.titleBar}>
            <div className={_.title}><RollingTitle/></div>
            <div id={TITLE_ANCHOR_ID}></div>
        </div>}
    </div>
        <FooterNotifications rootElementRef={rootRef} containerName={'network'} fadingOut={!isNetworkRoot}/>
    </>
}
